import {CallJs} from "../lib/types";
import {advancedSearchTemplate as news2_advancedSearchTemplate} from './advancedSearch/AdvancedSearch';
import {sendDetailsToSelf as news2_sendDetailsToSelf} from './email details to myself';
import {renderStatisticsField as news2_renderStatisticsField} from './statistics';

export const advancedSearchTemplate = news2_advancedSearchTemplate
export const sendDetailsToSelf = news2_sendDetailsToSelf
export const renderStatisticsField = news2_renderStatisticsField


// WEBPACK FOOTER //
// ./src/news2/news2.ts